// extracted by mini-css-extract-plugin
export var sliderRange = "_qd-2";
export var sliderRoot = "_qd-0";
export var sliderThumb = "_qd-3";
export var sliderTrack = "_qd-1";